import { render, staticRenderFns } from "./Siderbar.vue?vue&type=template&id=7c4e27f2&scoped=true"
import script from "./Siderbar.vue?vue&type=script&lang=js"
export * from "./Siderbar.vue?vue&type=script&lang=js"
import style0 from "./Siderbar.vue?vue&type=style&index=0&id=7c4e27f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4e27f2",
  null
  
)

export default component.exports